import { useEffect, useState } from 'react';
import { Package } from 'lucide-react';
import { apiService, PackAttachable, PackItemDTO } from '@/services/api.service';
import { ConfigCatalog } from '@/components/config/ConfigCatalog';
import { PackThumbnail } from '@/components/config/PackThumbnail';
import { PlayerPreview } from '@/components/config/PlayerPreview';
import { ItemEditor } from '@/components/config/ItemEditor';
import styles from '@/components/config/PackDetail.module.scss';

export function ItemsPage() {
  return (
    <ConfigCatalog<PackItemDTO>
      title="Items"
      icon={Package}
      kind="item"
      load={async (g) => (await apiService.getPackItems(g)).data?.items ?? []}
      keyOf={(i) => i.identifier}
      identifierOf={(i) => i.identifier}
      subtitleOf={(i) => i.pack}
      thumbnailOf={(i) => i.iconPath}
      matches={(i, q) => i.identifier.toLowerCase().includes(q) || i.pack.toLowerCase().includes(q)}
      sourceOf={(i) => i.source}
      renderDetail={(i, g, reload, group, visible) => <ItemDetail item={i} groupId={g} reload={reload} readonlyResource={!!group?.resourceReadonly} visible={visible !== false} />}
    />
  );
}

function ItemDetail({ item, groupId, reload, readonlyResource, visible }: { item: PackItemDTO; groupId: string; reload: () => void; readonlyResource: boolean; visible: boolean }) {
  const [attachable, setAttachable] = useState<PackAttachable | null>(null);

  useEffect(() => {
    let cancelled = false;
    setAttachable(null);
    apiService.getPackAttachable(groupId, item.identifier).then((res) => {
      if (!cancelled && res.data?.exists) setAttachable(res.data);
    });
    return () => { cancelled = true; };
  }, [groupId, item.identifier]);

  return (
    <div>
      <div className={styles.head}>
        <div>
          <div className={styles.name}>{item.identifier}</div>
          <div className={styles.pack}>{item.pack}</div>
        </div>
      </div>

      <div className={styles.previewRow}>
        <div className={styles.iconWrap}>
          <PackThumbnail groupId={groupId} path={item.iconPath} size={96} alt={item.identifier} />
          <div className={styles.previewLabel}>Icône</div>
        </div>

        <div className={styles.playerWrap}>
          {visible && <PlayerPreview groupId={groupId} identifier={item.identifier} iconPath={item.iconPath} attachable={attachable} />}
        </div>
      </div>

      <ItemEditor item={item} groupId={groupId} onSaved={reload} readonlyResource={readonlyResource} />
    </div>
  );
}
